import { db, DefectIndicator } from 'technical/db';

export const defectIndicatorSyncService = {
  async download(indicators: DefectIndicator[]): Promise<void> {
    await db.defectIndicators.bulkPut(indicators);
  },

  async reset(): Promise<void> {
    await db.defectIndicators.clear();
  },
};
